import request from '@/sheep/request';

export interface LimitProjectPkAcceptReq {
	projectId : number;
	player1UserProjectId : number;
	days : number;
}

export const getLimitProjectPkInviteInfo = async (userProjectId : number) => {
	return request({
		url: '/wish/limit-project-pk/invite-info',
		method: 'GET',
		params: { userProjectId },
		custom: { auth: false }
	});
};

export const acceptLimitProjectPk = async (data : LimitProjectPkAcceptReq) => {
	return request({
		url: '/wish/limit-project-pk/accept',
		method: 'POST',
		data,
		custom: { auth: true, showSuccess: true, successMsg: '挑战发起成功' }
	});
};

export const getLimitProjectPkProgress = async (id : number) => {
	return request({
		url: '/wish/limit-project-pk/progress',
		method: 'GET',
		params: { id },
		custom: { auth: false }
	});
};

export const getLimitProjectPkResult = async (id : number) => {
	return request({
		url: '/wish/limit-project-pk/result',
		method: 'GET',
		params: { id },
		custom: { auth: false }
	});
};

export const getMyLimitProjectPkPage = async (params ?: { pageNo ?: number; pageSize ?: number; status ?: number | null }) => {
	return request({
		url: '/wish/limit-project-pk/my/page',
		method: 'GET',
		params: {
			pageNo: params?.pageNo || 1,
			pageSize: params?.pageSize || 20,
			...(params?.status !== undefined && params?.status !== null ? { status: params.status } : {})
		},
		custom: { auth: true }
	});
};